import { GAME_PAYMENT_MODE } from "../../../constants/game";

export const getPlainTextFromHtml = (html) => {
  if (!html) return "";
  if (typeof document === "undefined") return html.trim();
  const container = document.createElement("div");
  container.innerHTML = html;
  return (container.textContent || container.innerText || "").trim();
};

export const validateRevolutLink = (link) => {
  if (!link) {
    return "Revolut link is required";
  }

  const trimmedLink = link.trim();

  if (
    !trimmedLink.includes("revolut.me/") &&
    !trimmedLink.includes("https://revolut.me/")
  ) {
    return "Link must be a valid Revolut payment link (revolut.me/yourcode or https://revolut.me/yourcode)";
  }

  return "";
};

export const isSportVisibilityValid = (gameData) =>
  !!gameData.sport && !!gameData.visibility;

export const isDateTimeValid = (gameData) => {
  if (!gameData.date || !gameData.time) return false;
  if (gameData.recurring === null || gameData.recurring === undefined) {
    return false;
  }
  const selectedDateTime = new Date(`${gameData.date}T${gameData.time}`);
  return selectedDateTime > new Date();
};

export const isLocationValid = (gameData) =>
  !!gameData.venue?.trim() && !!gameData.location?.address?.trim();

export const isPlayerDetailsValid = (gameData) => !!gameData.players;

export const isRefundCutoffValid = (gameData) => {
  if (
    gameData.payment_mode !== GAME_PAYMENT_MODE.IN_APP ||
    gameData.refund_policy !== "CUSTOM_CUTOFF"
  ) {
    return true;
  }
  const hours = parseInt(gameData.refund_cutoff_hours, 10);
  return Number.isInteger(hours) && hours >= 1 && hours <= 168;
};

export const isPaymentValid = (gameData) => {
  if (!gameData.payment_mode) return false;
  const amount = parseFloat(gameData.playerAmount);
  if (gameData.playerAmount === "" || gameData.playerAmount == null) {
    return false;
  }
  if (Number.isNaN(amount) || amount < 0) {
    return false;
  }
  if (
    gameData.payment_mode === GAME_PAYMENT_MODE.SELF &&
    gameData.use_revolut
  ) {
    return !validateRevolutLink(gameData.revolut_link);
  }
  if (!isRefundCutoffValid(gameData)) {
    return false;
  }
  return true;
};

export const isGroupStepValid = ({
  selectedGroup,
  showCreateGroup,
  groupData,
}) =>
  showCreateGroup
    ? !!groupData.name.trim() && !!groupData.country && !!groupData.city
    : !!selectedGroup;
